<template>
  <svg
    width="71"
    height="52"
    viewBox="0 0 71 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="71" height="52" fill="white" />
    <path
      opacity="0.8"
      d="M32.2373 3.98438C44.641 3.98461 54.6963 14.0406 54.6963 26.4443C54.696 38.8478 44.6408 48.9031 32.2373 48.9033C19.8336 48.9033 9.77759 38.848 9.77734 26.4443C9.77734 14.0405 19.8334 3.98438 32.2373 3.98438ZM59.2236 20.2861C60.1239 20.2861 60.8545 21.0157 60.8545 21.916C60.8544 22.8162 60.1238 23.5459 59.2236 23.5459C58.3236 23.5456 57.5939 22.816 57.5938 21.916C57.5938 21.0159 58.3236 20.2864 59.2236 20.2861ZM13.0381 3.98438C14.8386 3.98448 16.2979 5.44462 16.2979 7.24512C16.2977 9.04551 14.8385 10.5048 13.0381 10.5049C11.2376 10.5049 9.77746 9.04558 9.77734 7.24512C9.77734 5.44456 11.2375 3.98438 13.0381 3.98438Z"
      fill="url(#paint0_radial_410_32615)"
    />
    <path
      d="M18.4727 28.6174C18.4727 29.4177 19.1214 30.0664 19.9216 30.0664L44.9165 30.0663C45.7168 30.0663 46.3655 29.4176 46.3655 28.6174V24.5492C46.3655 24.141 46.1933 23.7517 45.8912 23.4771L33.3938 12.1158C32.8411 11.6133 31.9971 11.6133 31.4444 12.1158L18.9469 23.4771C18.6449 23.7517 18.4727 24.141 18.4727 24.5492V28.6174Z"
      fill="url(#paint1_radial_410_32615)"
    />
    <path
      d="M22.0938 18.4744C22.0938 17.6741 22.7425 17.0254 23.5427 17.0254H41.2927C42.093 17.0254 42.7417 17.6741 42.7417 18.4744V31.5152C42.7417 32.3154 42.093 32.9642 41.2927 32.9642H23.5427C22.7425 32.9642 22.0938 32.3154 22.0938 31.5152V18.4744Z"
      fill="url(#paint2_radial_410_32615)"
    />
    <path
      d="M39.2354 27.1016C39.5535 27.1016 39.8113 27.3596 39.8115 27.6777C39.8115 27.996 39.5536 28.2539 39.2354 28.2539H26.3262C26.0081 28.2537 25.75 27.9959 25.75 27.6777C25.7502 27.3598 26.0082 27.1018 26.3262 27.1016H39.2354ZM39.2354 25.0273C39.5536 25.0273 39.8114 25.2853 39.8115 25.6035C39.8115 25.9218 39.5536 26.1797 39.2354 26.1797H26.3262C26.0081 26.1795 25.75 25.9217 25.75 25.6035C25.7501 25.2855 26.0081 25.0276 26.3262 25.0273H39.2354Z"
      fill="url(#paint3_radial_410_32615)"
    />
    <path
      d="M18.1094 38.9149C18.1094 38.4787 18.3293 38.0719 18.6942 37.8329L40.1543 23.7817C40.3902 23.6272 40.666 23.545 40.948 23.545L45.2777 23.545C46.078 23.545 46.7267 24.1937 46.7267 24.994V38.7592C46.7267 39.5595 46.078 40.2082 45.2777 40.2082H19.4027C18.6884 40.2082 18.1094 39.6292 18.1094 38.9149Z"
      fill="url(#paint4_radial_410_32615)"
    />
    <path
      d="M46.7266 38.9149C46.7266 38.4787 46.5067 38.0719 46.1417 37.8329L24.6817 23.7817C24.4458 23.6272 24.1699 23.545 23.888 23.545L19.5582 23.545C18.7579 23.545 18.1092 24.1937 18.1092 24.994V38.7592C18.1092 39.5595 18.7579 40.2082 19.5582 40.2082H45.4333C46.1475 40.2082 46.7266 39.6292 46.7266 38.9149Z"
      fill="url(#paint5_radial_410_32615)"
    />
    <path
      d="M37.3743 22.1899C37.303 22.494 37.5337 22.7851 37.846 22.7851C38.1583 22.7851 38.389 22.494 38.3176 22.1899L38.142 21.4415L38.7962 22.0084C38.9949 22.1806 39.2979 22.1488 39.4565 21.939C39.6424 21.6931 39.5349 21.3374 39.2439 21.2357L38.4297 20.9511L39.2297 20.6897C39.5273 20.5925 39.6433 20.2331 39.4587 19.9802C39.2997 19.7625 38.9886 19.7271 38.7849 19.9037L38.142 20.4608L38.3176 19.7123C38.389 19.4083 38.1583 19.1172 37.846 19.1172C37.5337 19.1172 37.303 19.4083 37.3743 19.7123L37.55 20.4608L36.9136 19.9389C36.6819 19.7489 36.3351 19.8129 36.1865 20.073C36.0244 20.3567 36.1843 20.7163 36.5037 20.7859L37.2622 20.9511L36.4662 21.2431C36.224 21.3319 36.113 21.6116 36.2284 21.8423C36.3524 22.0904 36.6747 22.1592 36.8892 21.9833L37.55 21.4415L37.3743 22.1899Z"
      fill="url(#paint6_radial_410_32615)"
    />
    <path
      d="M31.9407 22.1899C31.8694 22.494 32.1001 22.7851 32.4124 22.7851C32.7247 22.7851 32.9554 22.494 32.884 22.1899L32.7084 21.4415L33.3626 22.0084C33.5613 22.1806 33.8643 22.1488 34.0229 21.939C34.2088 21.6931 34.1013 21.3374 33.8103 21.2357L32.9961 20.9511L33.7961 20.6897C34.0937 20.5925 34.2097 20.2331 34.0251 19.9802C33.8662 19.7625 33.555 19.7271 33.3513 19.9037L32.7084 20.4608L32.884 19.7123C32.9554 19.4083 32.7247 19.1172 32.4124 19.1172C32.1001 19.1172 31.8694 19.4083 31.9407 19.7123L32.1164 20.4608L31.48 19.9389C31.2483 19.7489 30.9015 19.8129 30.7529 20.073C30.5908 20.3567 30.7507 20.7163 31.0701 20.7859L31.8286 20.9511L31.0326 21.2431C30.7904 21.3319 30.6794 21.6116 30.7948 21.8423C30.9188 22.0904 31.2411 22.1592 31.4556 21.9833L32.1164 21.4415L31.9407 22.1899Z"
      fill="url(#paint7_radial_410_32615)"
    />
    <path
      d="M26.5071 22.1899C26.4358 22.494 26.6665 22.7851 26.9788 22.7851C27.2911 22.7851 27.5218 22.494 27.4504 22.1899L27.2748 21.4415L27.929 22.0084C28.1277 22.1806 28.4307 22.1488 28.5893 21.939C28.7753 21.6931 28.6677 21.3374 28.3767 21.2357L27.5625 20.9511L28.3625 20.6897C28.6601 20.5925 28.7761 20.2331 28.5915 19.9802C28.4326 19.7625 28.1214 19.7271 27.9177 19.9037L27.2748 20.4608L27.4504 19.7123C27.5218 19.4083 27.2911 19.1172 26.9788 19.1172C26.6665 19.1172 26.4358 19.4083 26.5071 19.7123L26.6828 20.4608L26.0464 19.9389C25.8148 19.7489 25.468 19.8129 25.3193 20.073C25.1572 20.3567 25.3172 20.7163 25.6365 20.7859L26.395 20.9511L25.599 21.2431C25.3568 21.3319 25.2458 21.6116 25.3612 21.8423C25.4852 22.0904 25.8075 22.1592 26.022 21.9833L26.6828 21.4415L26.5071 22.1899Z"
      fill="url(#paint8_radial_410_32615)"
    />
    <path
      d="M25.3555 36.5859C25.7555 36.5861 26.0801 36.9105 26.0801 37.3105C26.0799 37.7104 25.7554 38.035 25.3555 38.0352H20.6465C20.2465 38.0352 19.922 37.7105 19.9219 37.3105C19.9219 36.9104 20.2464 36.5859 20.6465 36.5859H25.3555ZM28.2529 34.4121C28.653 34.4121 28.9775 34.7366 28.9775 35.1367C28.9775 35.5368 28.6531 35.8613 28.2529 35.8613H20.6465C20.2464 35.8613 19.9219 35.5368 19.9219 35.1367C19.9219 34.7366 20.2464 34.4121 20.6465 34.4121H28.2529Z"
      fill="url(#paint9_radial_410_32615)"
    />
    <defs>
      <radialGradient
        id="paint0_radial_410_32615"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(52.1605 -9.23773) rotate(115.438) scale(69.9988 69.9988)"
      >
        <stop stop-color="#EAEEF9" />
        <stop offset="1" stop-color="#A3B1D1" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_410_32615"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(32.6002 24.6327) rotate(-88.5943) scale(29.5318 53.1618)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="0.99407" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_410_32615"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(34.9987 39.7427) rotate(-117.932) scale(25.7128 38.3511)"
      >
        <stop stop-color="#DDE3F0" />
        <stop offset="1" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_410_32615"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(27.1331 26.477) rotate(5.93537) scale(18.5407 5.16264)"
      >
        <stop stop-color="#D5DDEA" />
        <stop offset="1" stop-color="#DFE4EC" />
      </radialGradient>
      <radialGradient
        id="paint4_radial_410_32615"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(32.5992 51.8) rotate(-62.7004) scale(25.2742 24.8033)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="1" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint5_radial_410_32615"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(32.5751 71.612) rotate(-90) scale(56.3987 55.3478)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="0.714491" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint6_radial_410_32615"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(39.8327 21.6389) rotate(-180) scale(10.5967 10.6471)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="1" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint7_radial_410_32615"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(34.3992 21.6389) rotate(-180) scale(10.5967 10.6471)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="1" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint8_radial_410_32615"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(28.9656 21.6389) rotate(-180) scale(10.5967 10.6471)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="1" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint9_radial_410_32615"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(18.8352 44.7378) rotate(-64.6332) scale(19.4467 37.1958)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="1" stop-color="white" />
      </radialGradient>
    </defs>
  </svg>
</template>
